module.exports = __webpack_public_path__ + "static/media/send-your-package.e1df3006.jpeg";